import Icon from "../Icon";

const check = `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />`;

export default Icon(check);
